/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on MIT-LICENSE
 */
import { gql } from '@apollo/client'

export const SUPER_ADMIN_MASQUERADING = gql`
  query getSuperAdminMasquerading($customerId: Int!) {
    superAdminMasquerading(customerId: $customerId) {
      id
      companyName
      bcGroupName
      description
      catalogId
      companyStatus
      addressLine1
      addressLine2
      city
      state
      zipCode
      country
      extraFields {
        fieldName
        fieldValue
      }
    }
  }
`
